import { useSearchParams } from 'react-router-dom';
import { useOperatorStore } from '@/features/operator/store/operator-store';
import type { LatLng } from '@/types/global';
import type { ChargePointData } from '../types/charge-point.types';

/**
 * Start-charging and directions actions, shared by the details panel and
 * the mobile charger cards.
 */
export function useChargePointActions() {
  const [searchParams] = useSearchParams();
  const operator = useOperatorStore((s) => s.operator);

  const startCharging = (chargePoint: ChargePointData) => {
    if (chargePoint.webAppUrl) {
      window.open(chargePoint.webAppUrl, '_blank', 'noopener,noreferrer');
      return;
    }

    const params = new URLSearchParams();
    params.set('cp', chargePoint.id.toString());

    // Keep the operator theming when the map runs under an operator
    const operatorParam = searchParams.get('operator');
    if (operatorParam && operator) {
      params.set('operator', operatorParam);
      params.set('application', operatorParam);
    }

    window.open(
      `https://web-app.monta.app/?${params.toString()}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  const openDirections = ({ lat, lng }: LatLng) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`,
      '_blank',
      'noopener,noreferrer'
    );
  };

  return { startCharging, openDirections };
}
